import * as React from 'react';

export default ({ viewBox, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox={viewBox} style={style}>
    <rect width="40" height="40" rx="6" fill="#0A66C2" />
    <path
      fill="#fff"
      d="M14.1 16.2H10.6V29h3.5V16.2zm.23-4.02a2.03 2.03 0 10-4.06 0 2.03 2.03 0 004.06 0zM29.4 29h-3.49v-6.24c0-1.49-.03-3.4-2.07-3.4-2.07 0-2.39 1.62-2.39 3.29V29h-3.49V16.2h3.35v1.75h.05c.47-.88 1.6-1.81 3.3-1.81 3.53 0 4.18 2.32 4.18 5.35V29z"
    />
  </svg>
);
